import Box from "@mui/material/Box";
import {
  Autocomplete,
  CircularProgress,
  Grid,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import Popper from "@mui/material/Popper";
import { PopperProps } from "@mui/material/Popper";
import AppButton from "../../common/AppButton";
import { useAppDispatch } from "../../../app/hooks";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { addMedicineInitialValues } from "../../forms/initialValues";
import { addMedicineValidationSchema } from "../../forms/validationSchemas";
import { AddMedicine } from "../../../features/medicine/medicineSlice";
import { useEffect, useState } from "react";
import { getMedicineFormulaData } from "../../../features/medicineFormula/medicineFormulaSlice";
import { getCategoryData } from "../../../features/category/categorySlice";
import { getManufacturerData } from "../../../features/manufacturer/manufacturerSlice";
import { Dropdown } from "../batch/dropdown";
import { PharmacySuperCategory, units } from "../../../utils/constants";
import AppModal from "../../common/AppModal";
import AddManufacturerModal from "../manufacturer/manufacturer-add-model";
import AddMedicineFormulaModal from "../medicineFormula/medicineFormula-add-model";
const BarcodeReader = require("react-barcode-reader").default;

const intialmedicinevalues = {
  categoryId: "",
  manufacturerId: "",
  selectedMed: "",
  doseValue: {
    textField: "",
    selectField: "",
  },
  isOpen: false,
  loading: false,
};
const initialErrors = {
  apiError: false,
  medicineNameError: "",
  medicineGenericNameError: "",
  medicineFormulaError: "",
  doseError: "",
  categoryError: "",
  manufacturerError: "",
};
interface IProps {
  handleClose: () => void;
  setOpenSnackbar: () => void;
  getMedicine: () => void;
  setOpenErrorToast?: any;
  setErrorMessage?: any;
  setMedicineId?: any;
}
const AddMedicineModal = ({
  handleClose,
  setOpenSnackbar,
  getMedicine,
  setOpenErrorToast,
  setErrorMessage,
  setMedicineId,
}: IProps) => {
  const dispatch = useAppDispatch();

  const [medicineFormData, setMedicineFormData] =
    useState<any>(intialmedicinevalues);
  const [medicineFormulaData, setMedicineFormulaData] = useState<any>(null);
  const [categoryData, setCategoryData] = useState<any>(null);

  const [manufacturerNameData, setManufacturerNameData] = useState<any>(null);
  const [errors, setErrors] = useState(initialErrors);
  const [medFormulaValue, setMedFormulaValue] = useState<any>("");
  const [medicineName, setMedicineName] = useState<any>("");
  const [genericName, setGenericName] = useState<any>("");
  const loading = medicineFormData.loading;
  const [medBarcode, setMedBarcode] = useState("");
  const [openManufacturerModal, setOpenManufacturerModal] = useState(false);
  const [addManufacturerId, setAddManufacturerId] = useState("");
  const [openFormulaModal, setOpenFormulaModal] = useState(false);
  const [addFormulaId, setAddFormulaId] = useState("");

  const handleScan = (data: any) => {
    if (data) {
      if (data === medBarcode) return;
      setMedBarcode(data);
    }
  };

  const handleBarChange = (e: any) => {
    let value = e?.target?.value.trim();
    if (value.length <= 13) {
      setMedBarcode(value);
    }
  };

  // const handleBarChange = (e: any) => {
  //   let value = e?.target?.value.trim();

  //   if (value.length > 13) {
  //     value = value.slice(-13);
  //   }

  //   setMedBarcode((prev) => (prev !== value ? value : prev));

  //   if (value.length === 13) {

  //   }
  // };

  const handleMedicineName = (event: any) => {
    const value = event?.target?.value;
    setMedicineName(value);
  };
  const handleMedicineGenericName = (event: any) => {
    const value = event?.target?.value;
    setGenericName(value);
  };

  const handleError = (err: any) => {
    console.error(err);
  };

  const handleChange = (event: any) => {
    setMedFormulaValue(event?.target?.value);
    setMedicineFormData((prev: any) => ({
      ...prev,
      isOpen: true,
    }));
  };

  const filtered_list =
    medFormulaValue != null
      ? medicineFormulaData?.payload?.drug_formula
          ?.filter(function (item: any) {
            return item?.name
              ?.toLowerCase()
              ?.startsWith(medFormulaValue?.toLowerCase());
          })
          ?.filter(
            (item: any, index: number, self: any[]) =>
              index ===
              self?.findIndex(
                (t) =>
                  t?.name?.trim()?.toLowerCase() ===
                  item?.name?.trim()?.toLowerCase()
              )
          )
      : medicineFormulaData;

  const handleTextFieldChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const { value } = event?.target;

    // Validate that the dose is not negative
    if (Number(value) < 0 || value === "-0") {
      setErrors((prevErrors) => ({
        ...prevErrors,
        doseError: "Dose cannot be negative",
      }));
      return;
    }
    setErrors((prevErrors) => ({
      ...prevErrors,
      doseError: "",
    }));

    setMedicineFormData((prevState: any) => ({
      ...prevState,
      doseValue: {
        ...prevState.doseValue,
        textField: value,
      },
    }));
  };

  const handleSelectChange = (
    event: React.ChangeEvent<{}>,
    value: string | null
  ) => {
    setMedicineFormData((prevState: any) => ({
      ...prevState,
      doseValue: {
        ...prevState?.doseValue,
        selectField: value || "",
      },
    }));
  };

  const fetchMedicineFormulaData = async () => {
    try {
      const data: any = await dispatch(getMedicineFormulaData());
      setMedicineFormulaData(data);
    } catch (error) {
      console.error("Error fetching supplier data:", error);
    }
  };
  useEffect(() => {
    fetchMedicineFormulaData();
  }, []);

  const fetchCategoryData = async () => {
    try {
      const data: any = await dispatch(getCategoryData());
      // Ensure payload is an array before filtering
      const categoryArray = Array?.isArray(data?.payload?.category)
        ? data?.payload?.category
        : [];

      const super_category = categoryArray?.filter(
        (item: any) => item?.super_category === PharmacySuperCategory.MEDICAL
      );
      setCategoryData(super_category);
    } catch (error) {
      console.error("Error fetching supplier data:", error);
    }
  };

  useEffect(() => {
    fetchCategoryData();
  }, []);

  const fetchManufacturerNameData = async () => {
    try {
      const data: any = await dispatch(getManufacturerData());
      setManufacturerNameData(data);
    } catch (error) {
      console.error("Error fetching supplier data:", error);
    }
  };
  useEffect(() => {
    fetchManufacturerNameData();
  }, []);

  const handleSubmit = async (values: any) => {
    // Validate Medicine formula field
    if (!medicineName) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        medicineNameError: "Required *",
      }));
    } else {
      setErrors((prevErrors) => ({
        ...prevErrors,
        medicineNameError: "",
      }));
    }

    // if (!genericName) {
    //   setErrors((prevErrors) => ({
    //     ...prevErrors,
    //     medicineGenericNameError: "Required *",
    //   }));
    // } else {
    //   setErrors((prevErrors) => ({
    //     ...prevErrors,
    //     medicineGenericNameError: "",
    //   }));
    // }

    if (!medicineFormData?.selectedMed) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        medicineFormulaError: "Required *",
      }));
    } else {
      setErrors((prevErrors) => ({
        ...prevErrors,
        medicineFormulaError: "",
      }));
    }

    if (!medicineFormData?.categoryId) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        categoryError: "Required *",
      }));
    } else {
      setErrors((prevErrors) => ({
        ...prevErrors,
        categoryError: "",
      }));
    }

    // Validate manufacturer name  field
    if (!medicineFormData?.manufacturerId) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        manufacturerError: "Required *", // Set error message for manufacturer
      }));
    } else {
      setErrors((prevErrors) => ({
        ...prevErrors,
        manufacturerError: "", // Clear the error message if valid
      }));
    }

    if (
      !medicineFormData?.selectedMed ||
      !medicineFormData?.categoryId ||
      !medicineFormData?.manufacturerId
    ) {
      return;
    }
    //setLoading(true);
    setMedicineFormData((prev: any) => ({ ...prev, loading: true })); // start the loader
    const pharmacyId = localStorage?.getItem("pharmacyId");
    const combinedDoseString = `${medicineFormData?.doseValue?.textField} ${medicineFormData?.doseValue?.selectField}`;

    const medicine: any = {
      medicine_name: medicineName,
      generic_name: genericName,
      dose: combinedDoseString,
      barcode: medBarcode,
      pharmacy_id: pharmacyId,
      category_id: medicineFormData?.categoryId,
      manufacturer_id: medicineFormData?.manufacturerId,
      drug_formula_id: medicineFormData?.selectedMed,
      super_category: PharmacySuperCategory.MEDICAL,
    };

    !medBarcode && delete medicine?.barcode;

    try {
      const res = await dispatch(AddMedicine(medicine));
      if (res?.payload?.success) {
        setMedicineId(res?.payload?.data?.id);
        getMedicine();
        setOpenSnackbar();
        handleClose();
      } else {
        setOpenErrorToast();
        setErrorMessage(res?.payload);
        setErrors((prevErrors) => ({
          ...prevErrors,
          apiError: true,
        }));
        setMedicineFormData((prev: any) => ({ ...prev, loading: false })); // Stop the loader
      }
    } catch (error) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        apiError: true,
      }));
      console.error("Error adding medicine: ", error);
    } finally {
      setMedicineFormData((prev: any) => ({ ...prev, loading: false })); // Stop the loader
    }
  };

  const filterOptions = (options: string[], { inputValue }: any) => {
    const normalizedInput = inputValue?.toLowerCase();
    return options
      .filter((option) => option?.toLowerCase()?.includes(normalizedInput))
      .sort((a, b) => {
        const aStartsWith = a?.toLowerCase()?.startsWith(normalizedInput);
        const bStartsWith = b?.toLowerCase()?.startsWith(normalizedInput);

        // Push items starting with input to the top
        if (aStartsWith && !bStartsWith) return -1;
        if (!aStartsWith && bStartsWith) return 1;

        // Otherwise, keep the default order
        return a.localeCompare(b);
      });
  };

  const CustomPopper = (props: PopperProps) => {
    return <Popper {...props} style={{ zIndex: 1500, ...props.style }} />;
  };

  const handleOpenManufacturerModal = () => {
    setOpenManufacturerModal(true);
  };
  const handleCloseManufacturerModal = () => {
    setOpenManufacturerModal(false);
  };
  const handleOpenFormulaModal = () => {
    setOpenFormulaModal(true);
  };
  const handleCloseFormulaModal = () => {
    setOpenFormulaModal(false);
  };

  useEffect(() => {
    if (!addManufacturerId) return;

    const manufacturers = manufacturerNameData?.payload?.manufacturer;

    if (!Array.isArray(manufacturers) || manufacturers.length === 0) return;

    const newManufacturer = manufacturers?.find(
      (manufacturer) => String(manufacturer?.id) === String(addManufacturerId)
    );

    if (newManufacturer) {
      setMedicineFormData((prev: any) => ({
        ...prev,
        manufacturerId: newManufacturer.id,
      }));
    }
  }, [addManufacturerId, manufacturerNameData?.payload?.manufacturer]);

  useEffect(() => {
    if (!addFormulaId) return;

    const medicineFormula = medicineFormulaData?.payload?.drug_formula;

    if (!Array.isArray(medicineFormula) || medicineFormula.length === 0) return;

    const newMedicineFormula = medicineFormula?.find(
      (formula) => String(formula?.id) === String(addFormulaId)
    );

    if (newMedicineFormula) {
      setMedicineFormData((prev: any) => ({
        ...prev,
        selectedMed: newMedicineFormula.id,
      }));
      setMedFormulaValue(newMedicineFormula.name);
    }
  }, [addFormulaId, medicineFormulaData?.payload?.drug_formula]);

  return (
    <>
      <BarcodeReader onError={handleError} onScan={handleScan} />

      <Formik
        initialValues={{}}
        // onSubmit={handleSubmit}
        onSubmit={() => {}}
      >
        <Form>
          <Box sx={{ mt: 0.5 }}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={4}>
                <Typography variant="h6" gutterBottom>
                  Bar Code
                </Typography>
                <Field
                  as={TextField}
                  fullWidth
                  variant="outlined"
                  placeholder="Enter barcode."
                  value={medBarcode}
                  onChange={handleBarChange}
                  inputProps={{
                    style: {
                      padding: "10px 12px",
                    },
                  }}
                />
                {/* {!isEdit && errors?.batchNoError && ( */}
              </Grid>

              <Grid item xs={12} sm={4}>
                <Typography variant="h6" gutterBottom>
                  Name
                </Typography>
                <Field
                  as={TextField}
                  fullWidth
                  variant="outlined"
                  value={medicineName}
                  placeholder="Enter Name"
                  onChange={handleMedicineName}
                  inputProps={{
                    style: {
                      padding: "10px 12px",
                    },
                  }}
                />

                <div
                  style={{
                    color: errors?.medicineNameError ? "red" : "red",
                    fontSize: "14px",
                    marginTop: "5px",
                  }}
                >
                  {errors?.medicineNameError && (
                    // <div>Medicine with this name already exists</div>
                    <>{errors?.medicineNameError}</>
                  )}
                </div>
              </Grid>

              <Grid item xs={12} sm={4}>
                <Typography variant="h6" gutterBottom>
                  Medical Formula
                </Typography>
                <div style={{ position: "relative", zIndex: 10 }}>
                  <Dropdown
                    data={filtered_list}
                    handleChange={handleChange}
                    isOpen={medicineFormData?.isOpen}
                    setIsOpen={(open: boolean) =>
                      setMedicineFormData((prev: any) => ({
                        ...prev,
                        isOpen: open,
                      }))
                    }
                    value={medFormulaValue}
                    medicine_value={(data: any) => {
                      setMedicineFormData((prev: any) => ({
                        ...prev,
                        selectedMed: data?.id,
                        isOpen: false,
                      }));
                    }}
                    is_formula_drop={true}
                    addNewMed={() => handleOpenFormulaModal()}
                  />
                </div>
                {errors?.medicineFormulaError && (
                  <div
                    style={{
                      color: "red",
                      fontSize: "14px",
                      marginTop: "5px",
                    }}
                  >
                    {errors?.medicineFormulaError}
                  </div>
                )}
              </Grid>

              <Grid item xs={12} sm={4}>
                <Typography variant="h6" gutterBottom>
                  Category
                </Typography>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={
                    Array.isArray(categoryData)
                      ? categoryData?.map((category: any) => category?.name)
                      : []
                  }
                  onChange={(event, value) => {
                    if (value) {
                      const selectedCategory = categoryData?.find(
                        (category: any) => category?.name === value
                      );
                      setMedicineFormData({
                        ...medicineFormData,
                        categoryId: selectedCategory?.id,
                      });
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Select Category"
                      sx={{
                        "& .MuiInputBase-input": {
                          padding: "1px 5px !important",
                        },
                      }}
                    />
                  )}
                />
                {errors?.categoryError && (
                  <div
                    style={{
                      color: "red",
                      fontSize: "14px",
                      marginTop: "5px",
                    }}
                  >
                    {errors?.categoryError}
                  </div>
                )}
              </Grid>

              <Grid item xs={12} sm={4}>
                <Typography variant="h6" gutterBottom>
                  Dose
                </Typography>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={7}>
                    {/* Use TextField */}
                    <TextField
                      fullWidth
                      variant="outlined"
                      name="dose"
                      placeholder="Enter Dose"
                      value={medicineFormData?.doseValue?.textField}
                      onChange={handleTextFieldChange}
                      inputProps={{
                        style: {
                          padding: "10px 12px",
                        },
                      }}
                    />
                  </Grid>
                  <Grid item xs={5}>
                    {/* Use Select for units*/}
                    <Autocomplete
                      disablePortal
                      id="combo-box-demo"
                      options={
                        Array.isArray(units)
                          ? units?.map((unit: any) => unit?.name)
                          : []
                      }
                      filterOptions={filterOptions}
                      onChange={handleSelectChange}
                      value={medicineFormData?.doseValue?.selectField}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder="Sel. Unit"
                          sx={{
                            "& .MuiInputBase-input": {
                              padding: "1px 5px !important", // Ensures padding is applied correctly
                            },
                          }}
                        />
                      )}
                    />
                  </Grid>
                </Grid>
                {errors?.doseError && (
                  <div
                    style={{
                      color: "red",
                      fontSize: "14px",
                      marginTop: "5px",
                    }}
                  >
                    {errors?.doseError}
                  </div>
                )}
              </Grid>

              <Grid item xs={12} sm={4}>
                <Typography variant="h6" gutterBottom>
                  Generic Name
                </Typography>
                <Field
                  as={TextField}
                  fullWidth
                  variant="outlined"
                  value={genericName}
                  onChange={handleMedicineGenericName}
                  placeholder="Enter Generic Name"
                  inputProps={{
                    style: {
                      padding: "10px 12px",
                    },
                  }}
                />
                {/* <div
                  style={{
                    color: errors?.medicineGenericNameError ? "red" : "red",
                    fontSize: "14px",
                    marginTop: "5px",
                  }}
                >
                  {errors?.medicineGenericNameError && (
                    <>{errors?.medicineGenericNameError}</>
                  )}
                </div> */}
              </Grid>

              <Grid item xs={12} sm={4}>
                <Typography variant="h6" gutterBottom>
                  Manufacturer Name
                </Typography>

                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  PopperComponent={CustomPopper}
                  // Find the manufacturer name based on the stored ID
                  value={
                    manufacturerNameData?.payload?.manufacturer.find(
                      (manufacturer: any) =>
                        String(manufacturer?.id) ===
                        String(medicineFormData.manufacturerId)
                    )?.name || null
                  }
                  options={
                    Array.isArray(manufacturerNameData?.payload?.manufacturer)
                      ? manufacturerNameData?.payload?.manufacturer?.map(
                          (manufacturer: any) => manufacturer?.name
                        )
                      : []
                  }
                  onChange={(event, value) => {
                    if (value) {
                      const selectedmanufacturer =
                        manufacturerNameData?.payload?.manufacturer?.find(
                          (manufacturer: any) => manufacturer?.name === value
                        );
                      setMedicineFormData({
                        ...medicineFormData,
                        manufacturerId: selectedmanufacturer?.id,
                      });
                    }
                  }}
                  ListboxProps={{
                    style: {
                      maxHeight: 200,
                      overflow: "auto",
                    },
                  }}
                  popupIcon={null}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Select Manufacturer"
                      sx={{
                        "& .MuiInputBase-input": {
                          padding: "1px 5px !important",
                        },
                      }}
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            <InputAdornment position="end">
                              <Typography
                                onClick={handleOpenManufacturerModal}
                                sx={{
                                  cursor: "pointer",
                                  color: "#0A8DD0",
                                  fontWeight: 400,
                                  fontSize: "14px",
                                  marginRight: -3,
                                }}
                              >
                                + Add as New
                              </Typography>
                            </InputAdornment>
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />
                  )}
                />

                {errors?.manufacturerError && (
                  <div
                    style={{
                      color: "red",
                      fontSize: "14px",
                      marginTop: "5px",
                    }}
                  >
                    {errors?.manufacturerError}
                  </div>
                )}
              </Grid>
            </Grid>
          </Box>

          <Box sx={{ mt: 1.5 }}>
            <AppButton
              variant="contained"
              color="primary"
              type="button"
              onClick={handleSubmit}
              title={
                loading ? <CircularProgress size={24} color="inherit" /> : "Add"
              }
              sx={{ float: "right" }}
              disabled={loading}
            />
          </Box>
        </Form>
      </Formik>

      <AppModal
        title="Add New Manufacturer"
        open={openManufacturerModal}
        handleClose={handleCloseManufacturerModal}
        fullScreen={false}
        maxWidth="sm"
      >
        <AddManufacturerModal
          handleClose={handleCloseManufacturerModal}
          setOpenSnackbar={setOpenSnackbar}
          getManufacturer={fetchManufacturerNameData}
          setAddManufacturerId={setAddManufacturerId}
        />
      </AppModal>
      <AppModal
        title="Add New Formula Name"
        open={openFormulaModal}
        handleClose={handleCloseFormulaModal}
        fullScreen={false}
        maxWidth="sm"
      >
        <AddMedicineFormulaModal
          handleClose={handleCloseFormulaModal}
          setOpenSnackbar={setOpenSnackbar}
          getMedicineFormula={fetchMedicineFormulaData}
          setAddFormulaId={setAddFormulaId}
        />
      </AppModal>
    </>
  );
};

export default AddMedicineModal;
